import Icon from "@assets/tsx/icon/pickerIcon";
import React from "react";
export default function List({ items, layout }) {
    return (React.createElement("div", { className: "ltg-list-wrap" }, (items === null || items === void 0 ? void 0 : items.length) > 0 && (React.createElement("ul", { className: `ltg-list${layout === 'horizontal' ? ' ltg-list-inline' : ''}` }, items.map(({ icon, text, _id }) => {
        return (React.createElement("li", { className: "ltg-list-item", key: _id },
            (icon === null || icon === void 0 ? void 0 : icon.iconClassName) && (React.createElement("span", { className: "ltg-list-item-icon" },
                React.createElement(Icon, Object.assign({}, icon)))),
            text && (React.createElement("div", { className: "ltg-list-item-text", dangerouslySetInnerHTML: { __html: text } }))));
    })))));
}
